import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';

import { generateSlug } from 'utilities/helpers/generateSlug';

import { PromotedPostView } from './view';

export const PromotedPost = ({ currentType }) => {
    const data = useStaticQuery(graphql`
        query {
            allPromoted {
                nodes {
                    slug
                    type
                    alternative_id
                    title
                    lead
                    image_main
                    promoted_title
                    promoted_lead
                    reading_time
                    promoted_image
                }
            }
        }
    `)?.allPromoted?.nodes;

    const selectPromotedPost = () => {
        const promotedPost = data.filter((currentValue) => currentType === generateSlug(currentValue.type));

        if (promotedPost.length) {
            return promotedPost[0];
        }

        return data[0];
    };

    return (
        <>
            {
                selectPromotedPost().alternative_id
                    ? <PromotedPostView currentType={ currentType } post={ selectPromotedPost() } />
                    : null
            }
        </>
    );
};

PromotedPost.propTypes = {
    currentType: PropTypes.string.isRequired
};